'use strict';

angular.module('impactx.attachments', []);